<template>
	<!-- HEADER -->
     
	<header style="background: rgba(0, 0, 0, 0.3);">
        <el-row>
            <el-col :span="24" style="text-align: left;"><el-button type="primary" size="small" round @click="openDialog(null)" >修改</el-button></el-col>
        </el-row>
       
		<div class="video-container">
            
        <div class="carousel" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
            <video ref="video" v-for="(video, index) in listData" :key="index" class="carousel-video" autoplay
                muted @click="togglePlay(index)" @ended="onVideoEnded" @play="handlePlay" @pause="handlePause">
                <source :src="video.img" type="video/mp4">
                <!-- <source src="../../../public/assets/img/Main/7017Beacon.mp4" type="video/mp4"> -->
            </video>
        </div>
        
        <div class="dots">
            <span v-for="(item, index) in listData" :key="index" :class="['dot', { active: index === currentIndex }]"
                @click.stop="goToSlide(index)"></span>
        </div>
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%">
          <el-form >
            
            <el-form-item label="图片" :label-width="formLabelWidth">
                <div>
                    <el-upload 
                      ref="upload"
                      :multiple="true"
                      :auto-upload="false"
                      :on-change="handleFileChange"
                      :on-remove="handleRemove"
                      :file-list="fileList"
                      action="" 
                    >
                      <el-button type="primary">选择文件</el-button>
                    </el-upload>
                    <!-- <el-button @click="saveInfo">上传文件</el-button> -->
                  </div>
                  <div>
                    <el-table :data="currentRow" style="border: none;min-height: 400px;height: calc(100%-300px);"  >
                        <el-table-column prop="name" label="文件" width="140">
                        </el-table-column>
                        <!-- <el-table-column label="文件" width="180">
                            <template #default="scope">
                              <img v-if="scope.row.type=='image'" :src="scope.row.img" alt="" style="width: 100px; height: auto;" />
                              <video ref="video" v-else-if="scope.row.type=='video'" autoplay muted >
                                    <source :src="scope.row.img" type="video/mp4">
                                </video>
                              <span v-else>无文件</span>
                            </template>
                          </el-table-column> -->
                        <el-table-column
                          label="操作">
                          <template slot-scope="scope">
                            <el-row>
                              <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="deleteProduct(scope.row)"></el-button>
                            </el-row>
                          </template>
                        </el-table-column>
                    </el-table>
                  </div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="saveInfo">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
          </div>
        </el-dialog>
	</div>
    </header>
	<!--- END HEADER -->
</template>

<script>
	import {getCenterPic,submitHomeFirst} from "@/api/rbac/home";
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
        const videoExtensions = ['mp4', 'webm', 'ogg', 'avi', 'mkv',''];
export default {
	data() {
		return {
			currentIndex: 0,
            listData:[],
            dialogVisible:false,
            currentRow:[],
            formLabelWidth:'120px',
			fileList:[],
			isImage:false,
            listDel:[],
		};
	},
    created() {
             this.loadDataList();
          },
	methods: {
        
		async loadDataList() {
            try {
				const params1={unionID:0,strType:'mainVideo'}
                getCenterPic(params1).then(res=>{
                    this.listData=[];
                    if (res.data.length==0) {
                        // console.log('111')
                    }
                    else{
                        res.data.forEach(comNew => {
                            const img={id:comNew.id,img:'../../../assets/img/Main/'+comNew.name,name:comNew.name}
                            this.listData.push(img);
                        });
                        // this.listData=['../../../assets/img/Main/7017Beacon.mp4']
                    }
                })
            } catch (error) {
            console.error('获取失败:', error);
            }
        },
        openDialog(item){
            this.fileList=[];
			if (this.listData.length==0) {
				this.currentRow=[]
			}
			else{
                this.currentRow=[];
               
                this.listData.forEach((item)=>{
                    const extension = item.img.split('.').pop().toLowerCase();
                    const row={img:item.img,type:'',id:item.id,name:item.name}
                    if (imageExtensions.includes(extension)) {
                        row.type="image";
                    }
                    if (videoExtensions.includes(extension)) {
                        row.type="video";
                    }
                    this.currentRow.push(row);
                });
			}
			if (this.currentRow==undefined||this.currentRow.length==0) {
				this.isImage=false;
			}
			else{
				this.isImage=true;
			}
			
			console.log(item)
			this.dialogVisible=true;
        },
		closeDialog(){
			this.dialogVisible=false;
			this.currentRow=[];
            this.fileList=[];
		},
		beforeUpload(file) {
            console.log(file)
            return false; // 阻止自动上传
        },
        handleFileChange(file, fileList) {
            console.log('fileList',fileList)
            // this.fileList=[];
            // this.fileList.push(file)
            // if (file.status === 'ready') {
            //     // 当文件状态为 ready 时，生成预览 URL
            //     const reader = new FileReader();
            //     reader.onload = (e) => {
            //     this.currentRow.img = e.target.result;
            //     };
            //     reader.readAsDataURL(file.raw);
            // }
            this.fileList=fileList;
        },
		handleRemove(file, fileList) {
            console.log('222',fileList);
            // this.fileList.splice(this.files.indexOf(fileList), 1);
            this.files.splice(this.files.indexOf(file), 1);
        },
        async deleteProduct(row){
            this.listDel.push(row.id);
            // const index = this.currentRow.findIndex(item => item.id === row.id);

            // console.log('index',this.currentRow[index].id)
            // console.log(this.currentRow[0])
            // if (index !== -1) {
            //     this.currentRow.splice(index, 1);
            // }
            this.currentRow  = this.currentRow.filter(item  => item.id  !== row.id)
            let arr=this.currentRow
            this.currentRow=[];
            this.currentRow
            console.log('arr',arr) 
        },
        async saveInfo(){
			const formData = new FormData();
			if (this.fileList.length==0&&this.currentRow.length==this.listData.length) {
				this.dialogVisible=false;
				this.currentRow=[];
			}
			else{
				this.fileList.forEach((file) => {
				formData.append('files[]', file.raw);
				});
				formData.append("strType","mainVideo");
				formData.append("partID",0);
                this.listDel.forEach((item)=>{
                    formData.append('list[]', item);
                })
				try {
					submitHomeFirst(formData).then(res=>{
						if (res.length==0) {
							alert('失败');
						}
						else{
							alert('成功');
							this.dialogVisible=false;
							this.currentRow=[];
                            this.fileList=[];
							this.loadDataList();
						}
					})
				} catch (error) {
					alert('未成功');
				}
			}
		},
        next() {
            // 直接改变 currentIndex 进行视频切换
            this.currentIndex = (this.currentIndex + 1) % this.listData.length;
            this.$nextTick(() => {
                // 确保视图更新后触发播放
                const video = this.$refs.video[this.currentIndex];
                if (video) {
                    video.play();
                }
            });
            },
            prev() {
            // 切换到上一个视频，循环播放
            if (this.listData.length > 0) {
                this.currentIndex =
                    (this.currentIndex - 1 + this.listData.length) % this.listData.length;
            }

            }, goToSlide(index) {
            if (this.listData.length > 0) {
                this.currentIndex = index
            }
            }, onVideoEnded() {
            this.next();
            }, togglePlay(index) {
            const video = this.$refs.video[index];
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
            }, handlePlay() {
            this.isPlaying = true; // 视频开始播放
            },
            handlePause() {
            this.isPlaying = false; // 视频暂停
            },

    },

}
</script>

<style scoped>
@import '../../assets/css/main.css';
@media (max-width: 768px) {
	:deep(.overlay .container .p-5) {
		padding: 1rem !important;
	}
}

@media (max-width: 768px) {
	:deep(.overlay .container .font-weight-light) {
		display: none;
	}
}
.pHeader{
	color: white;
	background: red;
	font-size: 30px;
	display: inline-block;
    vertical-align: top; 
	padding: 0px 15px;
	font-weight: bold;
	font-family: 'DengXian', 'DengXian Mono', sans-serif;
}
:deep(.video-container) {
	position: relative;
	margin: 0 auto;
}

:deep(.video-container video) {
	width: 100%;
	height: auto;
	display: block;
	object-fit: cover;
	max-height: 800px;
}

:deep(.carousel-container) {
	position: relative;
	margin: 0 auto;
	overflow: hidden;
}

:deep(.carousel) {
	display: flex;
	transition: transform 0.5s ease-in-out;
}

:deep(.carousel-video) {
	min-width: 100%;
}

:deep(.overlay) {
	position: absolute !important;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: white;
	text-align: center;
	background: rgba(0, 0, 0, 0.4);
	z-index: 1;
	pointer-events: none;
}

:deep(.dots) {
	position: absolute;
	top: unset;
	bottom: 1.25rem;
}
</style>
